// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-team-inscription__container{
    background: var(--white-color);
    box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25);
    border-radius: 8px;
    margin-top: 22px;    
}

.select-team-inscription__page-data .baloa-normal-medium{
    color: var(--primary-very-dark-color);
    text-align: center;
}

.select-team-inscription__page-data .baloa-names{
    color: var(--basic-gray-color);
    text-align: center;
}

.select-team-inscription__page-data .icon-ball{
    font-size: 80px;
    display: flex;
    padding: 5px;
    width: 100%;
    height: 100%;
    font-weight: var(--font-bold);
    color: var(--white-color);
    border-radius: 50%;
    justify-content: center;
    align-items: center;
}

.select-team-inscription__page-data__img {
    width: 100px;
    height: 100px;
    margin: auto;
}

.select-team-inscription__page-data__img img{
    width: 100%;
    height: 100%;
    border-radius: 50%;
}

.select-team-inscription__subtitle.baloa-names{
    margin-top: 32px;
    color: var(--primary-very-dark-color);
    padding: 0 82px;
}

.select-team-inscription__teams-data__container{
    margin-top: 12px;
    border-radius: 4px;
    border: 1px solid var(--new-gray-background-color);
    padding: 12px 82px;
}

.grid-columns-set{
    display: grid;
    grid-template-columns: 2fr repeat(3, 1fr);
    grid-column-gap: 0px;
}

.select-team-inscription__teams-data__header {
    background: var(--new-background-color);
    border-radius: 7px;
    padding: 6px 24px;
    align-items: center;
}

.select-team-inscription__teams-data__header .baloa-table-column{
    color: var(--basic-gray-color);
}

.select-team-inscription__teams-data__team{
    align-items: center;
    padding: 14px 20px;
}

.select-team-inscription__teams-data__team .baloa-names {
    color: var(--primary-very-dark-color);
}

.select-team-inscription__teams-data__team .baloa-mini{
    color: var(--primary-very-dark-color);
    font-weight: var(--font-medium);
    font-size: 12px;
    line-height: 14px;
}

.select-team-inscription__teams-data__team__name{
    display: flex;
    align-items: center;
}

.select-team-inscription__teams-data__team__name-image {
    margin-right: 10px;
}

.select-team-inscription__teams-data__team__name-image img{
    width: 34px;
    height: 34px;
    border-radius: 50%;
}

.select-team-inscription__teams-data__team__name-image .icon-ball{
    font-size: 26px;
    display: flex;
    padding: 4px;
    font-weight: var(--font-bold);
    color: var(--white-color);
    border-radius: 50%;
    justify-content: center;
    align-items: center;
}

.select-team-inscription__teams-data__team__name .baloa-names {
    color: var(--primary-very-dark-color);
}

.select-team-inscription__teams-data__team__name .baloa-username {
    color: var(--primary-dark-color);
}

.select-team-inscription__teams-data__team__button.small{
    padding: 8px 20px;
}

.select-team-inscription__close-header {
    text-align: right;
    padding: 16px 16px 0 0;
}

.select-team-inscription__close-header__icon {
    color: var(--primary-dark-color);
    font-size: var(--space-x2);
    cursor: pointer;
    align-self: right;
    margin-left: auto;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .select-team-inscription__container{
        box-shadow: none;
        border-radius: 0;
        margin-top: 0px;    
    }

    .select-team-inscription__data-tags{
        font-family: var(--secondary-font);
        font-style: normal;
        font-weight: var(--font-regular);
        font-size: 11px;
        line-height: 13px;
        padding-top: 2px;
        display: flex;
    }

    .select-team-inscription__tag{
        background: var(--new-grey-light-background-color);
        border: 1px solid var(--new-grey-border-color);
        border-radius: 25px;
        padding: 2px 6px;
        margin-right: 4px;
        color: var(--primary-dark-color);
    }

    .select-team-inscription__teams-data__container{
        border: none;
        margin-top: 0;
        padding: 0 12px;
    }

    .select-team-inscription__teams-data__team {
        padding: 10px 0;
    }

    .select-team-inscription__teams-data__team__name-image img {
        width: 28px;
        height: 28px;
    }

    .select-team-inscription__teams-data__team__name-image .icon-ball {
        font-size: 20px;
    }

    .select-team-inscription__teams-data__team__button.small {
        margin-left: auto;
    }
}

`, "",{"version":3,"sources":["webpack://./src/app/pages/components/select-team-inscription/SelectTeamInscriptionComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,iDAAiD;IACjD,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,qCAAqC;IACrC,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kDAAkD;IAClD,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,yCAAyC;IACzC,oBAAoB;AACxB;;AAEA;IACI,uCAAuC;IACvC,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;IACrC,+BAA+B;IAC/B,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,YAAY;IACZ,6BAA6B;IAC7B,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;IAChC,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,gBAAgB;QAChB,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,kCAAkC;QAClC,kBAAkB;QAClB,gCAAgC;QAChC,eAAe;QACf,iBAAiB;QACjB,gBAAgB;QAChB,aAAa;IACjB;;IAEA;QACI,kDAAkD;QAClD,8CAA8C;QAC9C,mBAAmB;QACnB,gBAAgB;QAChB,iBAAiB;QACjB,gCAAgC;IACpC;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":[".select-team-inscription__container{\n    background: var(--white-color);\n    box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25);\n    border-radius: 8px;\n    margin-top: 22px;    \n}\n\n.select-team-inscription__page-data .baloa-normal-medium{\n    color: var(--primary-very-dark-color);\n    text-align: center;\n}\n\n.select-team-inscription__page-data .baloa-names{\n    color: var(--basic-gray-color);\n    text-align: center;\n}\n\n.select-team-inscription__page-data .icon-ball{\n    font-size: 80px;\n    display: flex;\n    padding: 5px;\n    width: 100%;\n    height: 100%;\n    font-weight: var(--font-bold);\n    color: var(--white-color);\n    border-radius: 50%;\n    justify-content: center;\n    align-items: center;\n}\n\n.select-team-inscription__page-data__img {\n    width: 100px;\n    height: 100px;\n    margin: auto;\n}\n\n.select-team-inscription__page-data__img img{\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n}\n\n.select-team-inscription__subtitle.baloa-names{\n    margin-top: 32px;\n    color: var(--primary-very-dark-color);\n    padding: 0 82px;\n}\n\n.select-team-inscription__teams-data__container{\n    margin-top: 12px;\n    border-radius: 4px;\n    border: 1px solid var(--new-gray-background-color);\n    padding: 12px 82px;\n}\n\n.grid-columns-set{\n    display: grid;\n    grid-template-columns: 2fr repeat(3, 1fr);\n    grid-column-gap: 0px;\n}\n\n.select-team-inscription__teams-data__header {\n    background: var(--new-background-color);\n    border-radius: 7px;\n    padding: 6px 24px;\n    align-items: center;\n}\n\n.select-team-inscription__teams-data__header .baloa-table-column{\n    color: var(--basic-gray-color);\n}\n\n.select-team-inscription__teams-data__team{\n    align-items: center;\n    padding: 14px 20px;\n}\n\n.select-team-inscription__teams-data__team .baloa-names {\n    color: var(--primary-very-dark-color);\n}\n\n.select-team-inscription__teams-data__team .baloa-mini{\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-medium);\n    font-size: 12px;\n    line-height: 14px;\n}\n\n.select-team-inscription__teams-data__team__name{\n    display: flex;\n    align-items: center;\n}\n\n.select-team-inscription__teams-data__team__name-image {\n    margin-right: 10px;\n}\n\n.select-team-inscription__teams-data__team__name-image img{\n    width: 34px;\n    height: 34px;\n    border-radius: 50%;\n}\n\n.select-team-inscription__teams-data__team__name-image .icon-ball{\n    font-size: 26px;\n    display: flex;\n    padding: 4px;\n    font-weight: var(--font-bold);\n    color: var(--white-color);\n    border-radius: 50%;\n    justify-content: center;\n    align-items: center;\n}\n\n.select-team-inscription__teams-data__team__name .baloa-names {\n    color: var(--primary-very-dark-color);\n}\n\n.select-team-inscription__teams-data__team__name .baloa-username {\n    color: var(--primary-dark-color);\n}\n\n.select-team-inscription__teams-data__team__button.small{\n    padding: 8px 20px;\n}\n\n.select-team-inscription__close-header {\n    text-align: right;\n    padding: 16px 16px 0 0;\n}\n\n.select-team-inscription__close-header__icon {\n    color: var(--primary-dark-color);\n    font-size: var(--space-x2);\n    cursor: pointer;\n    align-self: right;\n    margin-left: auto;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .select-team-inscription__container{\n        box-shadow: none;\n        border-radius: 0;\n        margin-top: 0px;    \n    }\n\n    .select-team-inscription__data-tags{\n        font-family: var(--secondary-font);\n        font-style: normal;\n        font-weight: var(--font-regular);\n        font-size: 11px;\n        line-height: 13px;\n        padding-top: 2px;\n        display: flex;\n    }\n\n    .select-team-inscription__tag{\n        background: var(--new-grey-light-background-color);\n        border: 1px solid var(--new-grey-border-color);\n        border-radius: 25px;\n        padding: 2px 6px;\n        margin-right: 4px;\n        color: var(--primary-dark-color);\n    }\n\n    .select-team-inscription__teams-data__container{\n        border: none;\n        margin-top: 0;\n        padding: 0 12px;\n    }\n\n    .select-team-inscription__teams-data__team {\n        padding: 10px 0;\n    }\n\n    .select-team-inscription__teams-data__team__name-image img {\n        width: 28px;\n        height: 28px;\n    }\n\n    .select-team-inscription__teams-data__team__name-image .icon-ball {\n        font-size: 20px;\n    }\n\n    .select-team-inscription__teams-data__team__button.small {\n        margin-left: auto;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
